import { Lock, Sparkles } from "lucide-react";
import React, { useState } from "react";

import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
  TooltipProvider,
} from "@/components/ui/tooltip";
import { Link } from "@/lib/i18n";
import { cn } from "@/lib/utils";
import * as m from "@/paraglide/messages";
import { useAppSelector } from "@/services/hooks/redux.hooks";

import { Button } from "./ui/button";

interface Props {
  isCollapsed?: boolean;
  onClick?: () => void;
  className?: string;
}
export function PremiumCard({ isCollapsed, onClick, className }: Props) {
  const { subscription, loading } = useAppSelector((state) => state.user);
  const [isHovering, setIsHovering] = useState(false);

  if (subscription || loading) {
    return <></>;
  }

  return isCollapsed ? (
    <Link href="/checkout?trial=true" className="mt-16 px-2 ">
      <Button
        asChild
        className={cn("w-full", className)}
        variant="gooeyLeft"
        onClick={onClick}
        onMouseEnter={() => setIsHovering(true)}
        onMouseLeave={() => setIsHovering(false)}
      >
        <span>
          <div className="flex items-center justify-center gap-2 relative z-10">
            <div className="relative">
              <Lock
                className={cn(
                  "w-4 h-4 transition-all duration-300",
                  isHovering ? "opacity-0 scale-50" : "opacity-100 scale-100",
                )}
              />
              <Sparkles
                className={cn(
                  "w-4 h-4 absolute top-0 left-0 transition-all duration-300",
                  isHovering ? "opacity-100 scale-100" : "opacity-0 scale-50",
                )}
              />
            </div>
            <span>{m.maroon_candid_flea_pick()}</span>
          </div>

          {/* Subtle background effect */}
          <div className="absolute inset-0 bg-zinc-900 opacity-0 group-hover:opacity-30 transition-opacity duration-300"></div>

          {/* Shine effect */}
          <div
            className={cn(
              "absolute top-0 -left-[100%] w-1/3 h-full bg-white/10 skew-x-12 transition-all duration-700 ease-in-out",
              isHovering ? "left-[200%]" : "-left-[100%]",
            )}
          />
        </span>
      </Button>
    </Link>
  ) : (
    <div className="flex justify-center mt-8">
      <Link href="/checkout?trial=true">
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <Button
                asChild
                className={cn("w-full", className)}
                variant="gooeyLeft"
                onClick={onClick}
                onMouseEnter={() => setIsHovering(true)}
                onMouseLeave={() => setIsHovering(false)}
              >
                <span>
                  <div className="flex items-center justify-center gap-2 relative z-10">
                    <div className="relative">
                      <Lock
                        className={cn(
                          "w-4 h-4 transition-all duration-300",
                          isHovering
                            ? "opacity-0 scale-50"
                            : "opacity-100 scale-100",
                        )}
                      />
                      <Sparkles
                        className={cn(
                          "w-4 h-4 absolute top-0 left-0 transition-all duration-300",
                          isHovering
                            ? "opacity-100 scale-100"
                            : "opacity-0 scale-50",
                        )}
                      />
                    </div>
                  </div>

                  {/* Subtle background effect */}
                  <div className="absolute inset-0 bg-zinc-900 opacity-0 group-hover:opacity-30 transition-opacity duration-300"></div>

                  {/* Shine effect */}
                  <div
                    className={cn(
                      "absolute top-0 -left-[100%] w-1/3 h-full bg-white/10 skew-x-12 transition-all duration-700 ease-in-out",
                      isHovering ? "left-[200%]" : "-left-[100%]",
                    )}
                  />
                </span>
              </Button>
            </TooltipTrigger>
            <TooltipContent side="right">
              <p className="">{m.maroon_candid_flea_pick()}</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      </Link>
    </div>
  );
}
